module.exports = __webpack_public_path__ + "img/f874625.png";